import { Component, ViewChild } from '@angular/core';
import { ApiMethod } from '../../apimethods/api-method';
import { ApsStaffPortalModel } from './aps-staff-portal-model';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { GlobalConstants } from '../../common/global-constants';
import * as ngswal from "sweetalert";

declare var $;

@Component({
  selector: 'app-aps-staff-portal',
  templateUrl: './aps-staff-portal.component.html',
  styleUrls: ['./aps-staff-portal.component.css']
})
/** aps-staff-portal component*/
export class ApsStaffPortalComponent {
  modelItem: ApsStaffPortalModel = new ApsStaffPortalModel();
  dataTable: any; dataSet: any; @ViewChild('dataTable', { static: false }) table;

  constructor() {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <ApsStaffPortalModel>data["ApsStaffPortal"];
        this.LoadDataList();
        customfunctions.SetDateValues("#Txt_FromDate", "#Txt_ToDate");
      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }
  ngOnInit() {
    $('#page-header-search-dropdown,#page-header-user-dropdown').hide();
    $('a[href="#ArtMetadata"]').hide();
    $('#divArticleInfoMetadata').find('.modal-footer').hide();
    ApiMethod.getBaseUrl();
  }

  LoadDataList(): void {
    $("#LoadingImage").show();

    var fromDate = $('#Txt_FromDate').val();
    var toDate = $('#Txt_ToDate').val();

    var paramData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID,
      FromDate: fromDate.toString(),
      ToDate: toDate.toString(),
      JournalId: localStorage.JrnlFil,
      ArticleNo: localStorage.artId
    };

    ApiMethod.postMethod(this.modelItem.GetArticleList, paramData).subscribe(
      result => {
        this.dataSet = JSON.stringify(result.DataList); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let aColList = result.ColList;
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 120);
        dataItem.modulename = 'ApsStaffPortal';
        dataItem.infoPopupID = 'ID';
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        if (result.ArticleId != 0) {
          localStorage.aEID = result.ArticleId;
          this.showInfoPopUp();
        }

        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  ResetFilter() {
    customfunctions.SetDateValues("#Txt_FromDate", "#Txt_ToDate");
    this.LoadDataList();
  }

  showInfoPopUp() {
    //Set Metadata editable disable
    localStorage.metadataEdit = 'false';
    $('#btnPopupartMeta').trigger('click');
  }


}
